// extracted by mini-css-extract-plugin
export default {"content":"FrameView_content__JXF8g"};